// if some dynamic components are used frequently, a better way is to register them globally
export default {
  DisplayRow: require('./nested-Customer'),
  SubTrades: require('./nested-Trades'),
  Reports: require('./nested-Reports'),
  PortfolioReport: require('@/components/Accounts/PortfolioSummaryReport.vue'),
  UploadDocs: require('@/components/Accounts/UploadDocs'),
  Color: require('./td-Color'),
  CreatetimeTd: require('./td-Createtime'),
  CreatetimeTh: require('./th-Createtime'),
  Email: require('./td-Email'),
  Input: require('./td-Input'),
  IP: require('./td-IP'),
  Number: require('./td-number'),
  Timestamp: require('./td-timestamp'),
  Opt: require('./td-Opt'),
  fxOpt: require('./td-fxOpt'),
  marginOpt: require('./td-marginOpt'),
  controlReportOpt: require('./td-ControlReportOpt'),
  reportOpt: require('./td-reportOpt'),
  tradeOpt: require('./td-tradeOpt'),
  emailOpt: require('./td-emailOpt'),
  tradeApprove: require('./td-tradeApprove'),
  customerApprove: require('./td-customerApprove'),
  tradeSecurityOpt: require('./td-securityOpt'),
  transOpt: require('./td-transOpt'),
  UserOpt: require('./td-UserOpt'),
  FilterTh: require('./th-Filter'),
  VueElementLoading: require('vue-element-loading')
  // [Vue warn]: Do not use built-in or reserved HTML elements as component id: Filter
  // Filter: require('./th-Filter')
}
